import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66b215a1")

_pushScopeId("data-v-66b215a1")
const _hoisted_1 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = { class: "text-gray-lp-800 text-10px italic mt-0.5" }
const _hoisted_9 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DownloadAttachmentPreview = _resolveComponent("DownloadAttachmentPreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('clientManagement.managementDetail.taxInfoTitle')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.newestUpdated.updatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdated.updatedByName), 1),
    _createVNode("div", _hoisted_2, [
      (!_ctx.detailData.clientTax.isEfakturWithNik)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-6/12",
                label: _ctx.$t('clientManagement.managementDetail.taxRegistrationNumber'),
                value: _ctx.detailData.clientTaxNumber || '-'
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-6/12",
                label: _ctx.$t('clientManagement.managementDetail.taxPayerName'),
                value: _ctx.detailData.clientTax.taxPayerName || '-'
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-7/12",
                label: _ctx.$t('clientManagement.managementDetail.addressAsTaxId'),
                value: _ctx.detailData.clientTax.taxPayerAddress || '-'
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-7/12",
                label: _ctx.$t('clientManagement.managementDetail.taxInvoiceTransactionCode'),
                value: _ctx.taxTransactionCode
              }, null, 8, ["label", "value"])
            ])
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-6/12",
                label: _ctx.$t('clientManagement.managementDetail.nikNumber'),
                value: _ctx.detailData.clientTax.clientNikId || '-'
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-6/12",
                label: _ctx.$t('clientManagement.managementDetail.nameAsIdCard'),
                value: _ctx.detailData.clientTax.clientNikName || '-'
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-7/12",
                label: _ctx.$t('clientManagement.managementDetail.addressAsIdCard'),
                value: _ctx.detailData.clientTax.clientNikAddress || '-'
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                fontSize: 14,
                class: "w-7/12",
                label: _ctx.$t('clientManagement.managementDetail.taxInvoiceTransactionCode'),
                value: _ctx.taxTransactionCode
              }, null, 8, ["label", "value"])
            ])
          ], 64)),
      _createVNode(_component_DataWrapper, {
        class: "w-full",
        label: _ctx.$t('clientManagement.managementDetail.taxIdOrIdCardPhoto'),
        fontSize: 14
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_7, [
            (_ctx.detailData.clientTax.taxAttachment)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DownloadAttachmentPreview, {
                    dash: false,
                    name: _ctx.detailData.clientTax.fileNameTaxAttachment,
                    url: _ctx.detailData.clientTax.taxAttachment,
                    maxLength: 100,
                    showPreview: _ctx.canPreviewAttachment,
                    activityHeader: "access-attachment-client-parent"
                  }, null, 8, ["name", "url", "showPreview"]),
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.newestUpdatedTaxAttachment.updatedAt)) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdatedTaxAttachment.updatedByName), 1)
                ], 64))
              : (_openBlock(), _createBlock("p", _hoisted_9, "-"))
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ], 64))
})